export default "/credits/business/assets/98383ab26ca1f5a18f27e785454a431a.png";